import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const AnalysisScore = types.compose(
  BaseEntity,
  types.model('AnalysisScore', {
    scoreId: types.identifierNumber,
    runId: types.maybe(types.integer),
    planningId: types.maybe(types.integer),
    feasible: types.maybe(types.boolean),
    hardScore: types.maybe(types.integer),
    initScore: types.maybe(types.integer),
    mediumScore: types.maybe(types.integer),
    softScore: types.maybe(types.integer),
    startDate: types.maybe(types.string),
    endDate: types.maybe(types.string),
    name: types.maybe(types.string),
    description: types.maybe(types.string),
    solutionInitialized: types.maybe(types.boolean),
    status: types.string
  }),
);
